<template>
  <vue-seamless-scroll
    :data="newsList"
    :class-option="optionLeft"
    class="seamless-warp2"
  >
    <ul class="item">
      <li v-for="(item, i) in newsList" v-text="item.title" :key="i"></li>
    </ul>
  </vue-seamless-scroll>
</template>
<style lang="less" scoped>
.seamless-warp2 {
  overflow: hidden;
  height: 25px;
  width: 99999px;
  border: 1px solid red;
  ul.item {
    width: 820px;
    border: 1px solid green;
    li {
      border: 1px solid blue;
      width: 400px;
      float: left;
    }
  }
}
</style>
<script>
import vueSeamlessScroll from "vue-seamless-scroll";

export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      newsList: [
        {
          title: "A simple, seamless scrolling for Vue.js",
        },
        {
          title: "A curated list of awesome things related to Vue.js",
        },
      ],
    };
  },
  computed: {
    optionLeft() {
      return {
        direction: 2,
        limitMoveNum: 2,
      };
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/page/screen3.vue